import Configuration from '@/agilis/util/Configuration'

export default {
  namespaced: true,
  state: {
  },
  getters: {
    trackerDataTable (state, getters, rootState, rootGetters) {
      return Configuration.datatable.getDatatable({
        applicationId: rootGetters['contextStore/applicationId'],
        trackerTypeId: rootGetters['contextStore/trackerTypeId'],
        workspaceId: rootGetters['contextStore/workspaceId']
      })
    },
    headers (state, getters, rootState, rootGetters) {
      return Configuration.datatable.getHeaders(getters.trackerDataTable)
    },
    caption (state, getters, rootState, rootGetters) {
      return getters.trackerDataTable.caption
    }
  }
}
